import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import Nav from './Nav';
import Loans from './Loans';
import BulkUpdate from './BulkUpdate';
import BulkHornbillJob from './BulkHornbillJob';
import NoMatch from './404';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  }
}));

function App(props) {
    const classes = useStyles();  
    const LoansRoute = ({ children }) => {
      const Role = props.role.account.idToken.roles[0];
      return Role !== "BulkUpdate" || Role !== "AllPerms" ? children : <Navigate to="/bulkupdate"/>
    };

    const BulkUpdateRoute = ({ children }) => {
      const Role = props.role.account.idToken.roles[0];
      return Role === "BulkUpdate" || Role === "AllPerms" ? children : <Navigate to="/loans"/>
    };
    const BulkHornbillJobRoute = ({ children }) => {
      const Role = props.role.account.idToken.roles[0];
      return Role === "BulkJobUpdate" || Role === "AllPerms" ? children : <Navigate to="/loans"/>
    };

    return (
      <div className={classes.root}>
        <Router>
          <Nav role={props.role}></Nav>
          <Routes>
            <Route path="/loans" element={
              <LoansRoute >
                <Loans role={props.role}/>
              </LoansRoute>
            }></Route>
            <Route path="/bulkupdate" element={
              <BulkUpdateRoute>
                <BulkUpdate role={props.role}/>
              </BulkUpdateRoute>
            }></Route>
            <Route path="/bulkhornbilljob" element={
              <BulkHornbillJobRoute>
                <BulkHornbillJob role={props.role}/>
              </BulkHornbillJobRoute>
            }></Route>
            <Route patch="*" element={<NoMatch/>}></Route>
          </Routes>
        </Router>
      </div>
    );
}
export default App;